import React from 'react';
import classNames from 'classnames';
import defaultTheme from '../../themes/default';

const ModalBody = ({ className, children }) => (
  <div className={classNames(defaultTheme.modal.body, className)}>
    {children}
  </div>
);

export default ModalBody;
